import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input-v16';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IUserEvents } from 'src/app/models/user-events';
import { AumyeDashboardService } from 'src/app/services/aumye-dashboard.service';

@Component({
  selector: 'app-bulk-invite',
  templateUrl: './bulk-invite.component.html',
  styleUrls: ['./bulk-invite.component.scss'],
})
export class BulkInviteComponent {
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  @Input() userEvents: IUserEvents[];
  @Output() onSendBulkInvitation = new EventEmitter();
  @ViewChild('phoneInput', { static: false })
  phoneInput: NgxMatIntlTelInputComponent;
  @ViewChild('phoneInput', { read: ElementRef, static: false })
  phoneInputRef: ElementRef;

  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }
  screenInfo: ScreenType;
  isSendBulkInvite: boolean = false;
  fileName: string = 'No file selected';
  selectedFile: File | null = null;
  selectedAttachment: File | null = null;
  isFileSelected = false;
  isFileSelectedError = false;
  isFileSelectedErrorMessage = '';
  expectedHeaders = ['firstname', 'lastname', 'email', 'phone'];
  displayedColumns = [
    'index',
    'firstname',
    'lastname',
    'email',
    'phone',
    'detail',
  ];
  csvContent: string = null;
  attachmentContent: string = null;
  formatedCsvContent: [];
  iscsvContentFormated: boolean = false;
  dateSelected: Date = new Date();
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  typedCsvValues: TypedCSVFormat[] = [];
  isManualTypeValues = false;
  constructor(
    private formBuilder: FormBuilder,
    private _dashboardService: AumyeDashboardService
  ) {}

  bulkInviteForm = this.formBuilder.group({
    eventTitle: ['', [Validators.required]],
    inviteReason: ['', [Validators.required]],
    eventAttachment: [''],
    linkEvent: [''],
    uploadFileGuestList: [''],
    eventHost: [''],
    eventHostId: [''],
    eventDate: [this.dateSelected.toISOString(), [Validators.required]],
  });
  manualTypeForm = this.formBuilder.group({
    firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    email: ['', [Validators.email]],
    phoneNumber: ['', Validators.required],
  });
  sendBulkInvite() {
    this.isSendBulkInvite = true;
  }
  onChangeNumber(val: any) {
    // console.log(val);
  }
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
  typeManualValues() {
    this.isManualTypeValues = true;
    this.isFileSelected = false;
    setTimeout(() => {
      const targetElement = document.querySelector(
        '.mat-tile-button-attachment'
      );
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 250);
  }
  selectFile(): void {
    this.isManualTypeValues = false;
    this.isFileSelectedError = false;
    this.isFileSelectedErrorMessage = null;
    this.isFileSelected = false;
    this.fileInput.nativeElement.click();
  }
  onAttachmentSelected(event: any): void {
    const fileInput = event.target;
    if (fileInput.files && fileInput.files.length > 0) {
      this.selectedAttachment = fileInput.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const contents = e.target.result as string;
        this.attachmentContent = contents;
      };
      reader.readAsDataURL(this.selectedAttachment);
    } else {
      this.selectedAttachment = null;
    }
  }
  onFileSelected(event: Event): void {
    this.isFileSelectedError = false;
    this.isFileSelectedErrorMessage = null;
    const file = (event.target as HTMLInputElement).files[0];
    if (file) {
      // Validate the file here
      if (
        file.type === 'text/csv' ||
        file.type === 'application/vnd.ms-excel' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const contents = e.target.result as string;
          const lines = contents.split('\n');

          const firstLine = lines[0].trim();
          const headers = firstLine.split(',');
          if (
            headers.length === this.expectedHeaders.length &&
            headers.every(
              (header, index) =>
                header.toLowerCase() ===
                this.expectedHeaders[index].toLowerCase()
            )
          ) {
            this.selectedFile = file;
            this.isFileSelected = true;
            this.csvContent = contents;
            this.onGetFormatedContent();
          } else {
            this.isFileSelectedError = true;
            this.isFileSelectedErrorMessage = 'CSV does not contain headers';
          }
        };
        reader.readAsText(file);
      } else {
        this.isFileSelectedError = true;
        this.isFileSelectedErrorMessage = 'Invalid file type';
      }
    }
  }
  onGetFormatedContent() {
    this._dashboardService.onBulkUpload(this.csvContent).subscribe((res) => {
      this.formatedCsvContent = JSON.parse(res);
      this.iscsvContentFormated = true;
    });
  }
  getSelectedDate(val: Date) {
    this.dateSelected = val;
    this.bulkInviteForm.controls.eventDate.setValue(val.toISOString());
  }
  sendBulkInvites(val: any) {
    this.bulkInviteForm.controls.uploadFileGuestList.setValue(
      JSON.stringify(val)
    );
    this.bulkInviteForm.controls.eventAttachment.setValue(
      this.attachmentContent
    );
    this.bulkInviteForm.controls.eventHost.setValue(
      localStorage.getItem('FullName')
    );
    this.bulkInviteForm.controls.eventHostId.setValue(
      localStorage.getItem('UserId')
    );
    this.onSendBulkInvitation.emit(this.bulkInviteForm.value);
  }
  sendBulkTypesCsvInvites(val: any) {
    this.bulkInviteForm.controls.uploadFileGuestList.setValue(
      JSON.stringify(this.typedCsvValues)
    );
    this.bulkInviteForm.controls.eventAttachment.setValue(
      this.attachmentContent
    );
    this.onSendBulkInvitation.emit(this.bulkInviteForm.value);
  }
  addNewCsvValue() {
    const temp: TypedCSVFormat = {
      firstName: this.manualTypeForm.controls.firstName.value,
      lastName: this.manualTypeForm.controls.lastName.value,
      email: this.manualTypeForm.controls.email.value,
      phone: this.manualTypeForm.controls.phoneNumber.value,
    };
    this.typedCsvValues.push(temp);
    this.dataSource.data = this.typedCsvValues;
    this.manualTypeForm.reset();
    if (this.phoneInput) {
      const inputElement =
        this.phoneInputRef.nativeElement.querySelector('input');
      if (inputElement) {
        inputElement.value = ''; // Clear the actual input element
      }
      this.phoneInput.value = null; // Clear the ngx-mat-intl-tel-input component
    }
  }
  removeCsvValue(itemToRemove: TypedCSVFormat): void {
    const indexToRemove = this.typedCsvValues.findIndex(
      (item) => item === itemToRemove
    );
    if (indexToRemove !== -1) {
      this.typedCsvValues.splice(indexToRemove, 1);
      this.dataSource.data = [...this.typedCsvValues];
    }
  }
  gettypedCsvValues() {
    return this.typedCsvValues;
  }
  ScreenType = ScreenType;
}
export interface TypedCSVFormat {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}
